import {computed, Injectable, signal, WritableSignal} from '@angular/core';
import {
    EstadoTramiteEnum,
    FasesInterface,
    FormulaInterface,
    FrmItem,
    InitPayload,
    TarifarioEstadoDTO,
    TarifarioMantenimientoInterface,
    TarifarioTipoInterface,
    TrafifarioPorTramiteInterface,
    TramiteEstadoDTO,
    TramiteFormularioInstituciones,
    TramiteInterface,
    TramiteItem,
    TramiteMntDTO,
    TramiteRequisitoEstado,
    TramiteRequisitoOrden,
    TramiteRequisitosRqInterface,
    TramitesRequisitos,
    TramitesRequisitosSeleccionados,
    TramiteTipoRequisitoItem
} from '../components/interfaces/tramites.interface';
import {HttpClient} from '@angular/common/http';
import {CargoItem, TarifarioInterface} from '../../interfaces/pagos.interface';
import {environment} from 'src/environments/environment.development';
import {SdetTramiteService} from "./sdet-tramite.service";
import {LoginServices} from "../../../auth/login/services/login.service";
import {
    AreasInterfaces,
    DetalleConstruccionInterface,
    EtapasProyectoInterfaces,
    LoteInterface,
    ProfesionalesTablaInterface,
    RecepcionObrasDetalleInterface,
    RecepcionProyectoDetalleInterface,
    TipoObrasDetalleInterface,
    UnidadesHabitacionalesInterface,
} from "../components/interfaces/formulario.interfaces";
import {CacheService} from "../../../shared/services/cache-service";
import Swal from "sweetalert2";
import {SdetInterface} from "../components/interfaces/sdet.interface";
import {SolicitudEvalTramiteFase} from "../../../officials/evaluaciones/interfaces/evaluaciones.interface";
import {EvaluacionesService} from "../../../officials/evaluaciones/services/evaluaciones.service";
import {ProyectoItem} from "../../interfaces/proyecto.interface";
import {ProyectoService} from "../../proyectos/services/proyecto.service";

let apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class TramiteService {
    constructor(private http: HttpClient, private sdetTramiteService: SdetTramiteService,
                private loginServices: LoginServices, private cacheService: CacheService, private evaluacionesService:EvaluacionesService,
                private proyectoService: ProyectoService) {
    }

    /**
     *
     * Los estados permitidos en carrito son: 1,2 y 3. El carrito separa lógicamente los estados 2 y 3 para
     * aplicar control de flujo y datos requeridos.
     *
     * Todos los trámites pagados(4) se marcan como completados, el resto deben aparecer en el carrito cuando
     * han sido agregados por el usuario,
     *
     */
    tramitesCarrito: WritableSignal<TramiteItem[]> = signal([])
    /**
     * Estados permitidos en los trámites.<br/>
     * 0=Eliminado,
     * 1=En carrito,
     * 2=Formulario pendiente,
     * 3=Formulario completo,
     * 4=Pago realizado
     * <br/>
     * Esta lista contiene todos los servicios procesados por el usuario.
     */
    tramitesProcesados: WritableSignal<TramiteItem[]> = signal([])
    /**
     * Esta lista contiene todos los servicios que corresponden a la fase seleccionada.
     */
    tramitesPorFase: WritableSignal<TramiteItem[]> = signal([])
    idProyecto: WritableSignal<string | null> = signal(null)
    /**
     * 1= Flujo proyecto que implica respetar todos sus requerimientos.
     * 2= Flujo dinamico, abierto que le permitira al cliente seleccionar los tramites que necesita sin respetar el orden o flujo.
     */
    /**
     Esta es una lista de los requisitos, cuando se carga el archivo el estado
     de idArchivoEstadoRq=1
     */
    _requisitosFormularios: WritableSignal<TramiteRequisitosRqInterface[]> = signal([]);
    requisitosFormularios = computed(() => this._requisitosFormularios());
    /**Esta variable almacena el valor del resultado si existe o areas generelalidas del terreno previamente registradas en el form a*/
    //TODO: Refactorizar esto, 26/05/2025 10:35am
    areasGeneralidadesTerrenoCompletadas: WritableSignal<boolean> = signal(false);
    /**Esta vairable obtendra el valor del area que se utliza para el calculo de la tarifa*/
    areaTotalSignal = signal<number>(0);
    /**Esta variable almacena lista de areas que se utilizan en los formulario A,B,C*/
    tiposAreas: WritableSignal<AreasInterfaces[]> = signal([])
    progressBar: { [param: string]: number } = {};
    datosCargados: boolean = false;
    initPayload: WritableSignal<InitPayload | null> = signal(null)
    loading: WritableSignal<boolean> = signal(false);
    _tramitesFasesEval: WritableSignal<SolicitudEvalTramiteFase[]> = signal([]);
    tramitesFasesEval = computed(()=>this._tramitesFasesEval())
    /**Esta variable almacena la informacion del proyecto*/
    proyectoAsignado: WritableSignal <ProyectoItem[]> = signal([])
    /**Esta variable almacena informacion del proyecto en tramites */
    selected: WritableSignal<ProyectoItem | null> = signal(null)
    textTarifa: string = '';
    areaConstruccionSignal = signal<number>(0);
    limpiarDatosRequisitos() {
        this._requisitosFormularios.set([]);
    }

    getTramite(idTramite: string) {
        console.log(`idTramite -> ${idTramite}`)
        let url = apiVucUrl + `api/v1.0/tramites/${idTramite}`;
        return this.http.get<TramiteInterface>(url, {observe: 'response'})
    }

    getFormulariosPorInstitucion(idInstitucion: number) {
        console.log(`getFormulariosPorInstitucion()`);
        let url = apiVucUrl + `api/v1.0/instituciones/${idInstitucion}/formularios`;
        return this.http.get<TramiteFormularioInstituciones[]>(url)
    }

    getFormularios() {
        console.log(`getFormularios()`);
        let url = apiVucUrl + `api/v1.0/formularios`;
        return this.http.get<FrmItem[]>(url)
    }

    getFases() {
        console.log('getFases()')
        let url = apiVucUrl + 'api/v1.0/catalogos/fase';
        return this.http.get<FasesInterface[]>(url)
    }

    /**
     * Consulta global que permite obtener los requisitos asociados a un trámite y/o proyecto.
     */
    getRequisitosPorParametros(idTramite: string | null, idProyecto: string | null, idTipoTramite: TramiteTipoRequisitoItem[] | null) {
        console.log(`getRequisitosPorParametros -> idTramite=${idTramite}, idProyecto=${idProyecto}, idTipos=${idTipoTramite}`);
        const idTipos = idTipoTramite ? (idTipoTramite.map(t => t.idTipoTramite)) : '';
        let url = apiVucUrl + `api/v1.0/tramites/requisitos?idProyecto=${idProyecto}&idTramite=${idTramite ? idTramite : ''}&idTipos=${idTipos}`;
        console.log(url)
        return this.http.get<TramiteRequisitosRqInterface[]>(url)
            .subscribe({
                next: (result) => {
                    if (result) {
                        this._requisitosFormularios.set(result);
                        this.datosCargados = true;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }

    /**Metodo que sincroniza el progreso de la carga de un archivo, también actualiza el requisito en pantalla que corresponde al archivo*/
    updateProgressBar(idRequisito: number, progress: number) {
        if (this.progressBar != undefined) {
            this.progressBar[idRequisito] = progress;
        }
    }

    /**Metodo que sincroniza el progreso de la carga de un archivo, también actualiza el archivo en pantalla que corresponde al hash proporcionado*/
    updateProgressBarWithHash(hash: string, progress: number) {
        if (this.progressBar != undefined) {
            this.progressBar[hash] = progress;
        }
    }

    eliminarTramite(s: TramiteItem) {
        console.log(`eliminarServicio=${JSON.stringify(s)}`)
        if (s.idProyecto == null) {
            console.log(`idProyecto es invalido para= ${JSON.stringify(s.idTramite)}`)
        }
        const sdet: SdetInterface = {
            codigoInstitucion: Number.parseFloat(s.codigoInstitucion),
            idTramite: Number.parseFloat(s.idTramite),
            codigoProyecto: s.idProyecto,
            codigoSolicitud: s.idSolicitud,
            usuario: this.loginServices.session()?.perfil.usuario,
            codigoEstado: 0,
            idFase: Number.parseFloat(s.idFase),
            session: {
                uniqueId: this.loginServices.session()?.perfil.uniqueId,
                correo: this.loginServices.session()?.perfil.correo,
                usuario: this.loginServices.session()?.perfil.usuario!,
                documento: this.loginServices.session()?.perfil.documento
            }
        };
        return this.actualizarTramite(sdet)
    }

    startFormProcess(sdet: SdetInterface, eventType: string) {
        console.log(`startFormProcess -> sdet:${JSON.stringify(sdet)}, eventType=${eventType}`);
        return this.actualizarFullSdet(sdet, eventType);
    }

    completeFormProcess(s: TramiteItem) {
        console.log(`completeFormProcess -> s:${JSON.stringify(s)}`)
        if (s.idProyecto == null) {
            console.log(`idProyecto es invalido para= ${JSON.stringify(s.idTramite)}`)
        }
        const sdet: SdetInterface = {
            codigoInstitucion: Number.parseFloat(s.codigoInstitucion),
            idTramite: Number.parseFloat(s.idTramite),
            codigoProyecto: s.idProyecto,
            codigoSolicitud: s.idSolicitud,
            usuario: this.loginServices.session()?.perfil.usuario,
            codigoEstado: 3,
            idFase: Number.parseFloat(s.idFase),
            session: {
                uniqueId: this.loginServices.session()?.perfil.uniqueId,
                correo: this.loginServices.session()?.perfil.correo,
                usuario: this.loginServices.session()?.perfil.usuario,
                documento: this.loginServices.session()?.perfil.documento
            }
        };
        return this.actualizarTramiteObs(sdet)
    }

    /**
     * Este metodo se utiliza cuando se completa el formulario con tipo de flujo 2
     * y ya tiene asignado un proyecto
     */
    completeFormProcessAsignacion(s: TramiteItem) {
        console.log(`completeFormProcessAsignacion -> s:${JSON.stringify(s)}`)
        const sdet: SdetInterface = {
            codigoInstitucion: Number.parseFloat(s.codigoInstitucion),
            idTramite: Number.parseFloat(s.idTramite),
            codigoProyecto: s.idProyecto,
            codigoSolicitud: s.idSolicitud,
            usuario: this.loginServices.session()?.perfil.usuario,
            codigoEstado: 3,
            idFase: Number.parseFloat(s.idFase),
            session: {
                uniqueId: this.loginServices.session()?.perfil.uniqueId,
                correo: this.loginServices.session()?.perfil.correo,
                usuario: this.loginServices.session()?.perfil.usuario!,
                documento: this.loginServices.session()?.perfil.documento
            }
        };
        return this.actualizarTramiteObsAsignacion(sdet)
    }

    /**
     * Posibles estados de tramites:
     * 0=Eliminado,
     * 1=En carrito,
     * 2=Formulario pendiente,
     * 3=Formulario completo,
     * 4=Pago realizado
     */
    private actualizarTramiteObs(sdet: SdetInterface, eventType?: string) {
        return this.sdetTramiteService.updateStatusSdet(sdet, eventType)
    }

    /**
     * Posibles estados de tramites:
     * 0=Eliminado,
     * 1=En carrito,
     * 2=Formulario pendiente,
     * 3=Formulario completo,
     * 4=Pago realizado
     */
    private actualizarFullSdet(sdet: SdetInterface, eventType: string) {
        return this.sdetTramiteService.updateStatusFullSdet(sdet, eventType)
    }

    /**
     * Cuando ya se asgino un prooyecto
     * Posibles estados de tramites:
     * 0=Eliminado,
     * 1=En carrito,
     * 2=Formulario pendiente,
     * 3=Formulario completo,
     * 4=Pago realizado
     */
    private actualizarTramiteObsAsignacion(sdet: SdetInterface) {
        return this.sdetTramiteService.updateStatusSdetAsignacion(sdet)
    }

    /**
     * Posibles estados de tramites:
     * 0=Eliminado,
     * 1=En carrito,
     * 2=Formulario pendiente,
     * 3=Formulario completo,
     * 4=Pago realizado
     */
    private actualizarTramite(sdet: SdetInterface, eventType?: string) {
        this.loading.set(true)
        return this.sdetTramiteService.updateStatusSdet(sdet, eventType)
            .subscribe({
                next: (result) => {
                    if (result.status == 200 || result.status == 201) {
                        this.getTramitesDisponiblesPorProyecto(sdet.codigoProyecto!);
                        this.getGeneralesProyectoUpdate(sdet.codigoProyecto?.toString()!);
                    }
                },
                error: (error) => {
                    console.log(error)
                    this.loading.set(false)
                },
                complete: () => {
                    this.loading.set(false)
                }
            });
    }

    vaciarCarrito(items: TramiteItem[], usuario: string | null | undefined) {
        return this.sdetTramiteService.vaciarCarrito(items, usuario)
    }

    /**
     * Procesa el pago y sincroniza estados, tarifario y pago en todos los servicios existentes del carrito.
     */
    pagoDot(items: TramiteItem[], pago: CargoItem, usuario: string | null | undefined) {
        return this.sdetTramiteService.pagoDot(items, pago, usuario)
    }

    /**
     * Obtiene todos los servicios según los parametros especificados:
     *
     * <p><b>CASO 1:</b> Consultar trámites disponibles por fase y vinculados a un proyecto. idProyecto es obligatorio. Este caso retorna el estatus del item agregado</p>
     * <p><b>CASO 2:</b> Consultar trámites disponibles por fase. Este caso no retorna estado de seguimiento.</p>
     *
     */
    getTramitesDisponibles(idInstitucion: number, idFase: number, idProyecto: number) {
        console.log(`getTramitesDisponibles ->  idInstitucion=${idInstitucion}, idProyecto=${idProyecto},idFase=${idFase}`);
        let url = apiVucUrl + `api/v1.0/tramites/disponibles?idProyecto=${idProyecto}&idInstitucion=${idInstitucion}&idFase=${idFase}`;
        this.tramitesPorFase.set([])
        this.tramitesProcesados.set([])
        this.http.get<TramiteItem[]>(url, {observe: 'response'})
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tramitesPorFase.set(result.body)
                        this.tramitesProcesados.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                    setTimeout(() => {
                        this.filtrarTramitesCarrito();
                    }, 200)
                }
            });
    }

    /**
     * Obtiene todos los servicios según los parametros especificados:
     *
     * <p><b>CASO 3:</b> Consultar trámites disponibles y vinculados a un proyecto. idProyecto es obligatorio.
     *
     */
    getTramitesDisponiblesPorProyecto(idProyecto: number) {
        console.log(`getTramitesDisponiblesPorProyecto ->idProyecto=${idProyecto}`);
        let url = apiVucUrl + `api/v1.0/tramites/disponibles?idProyecto=${idProyecto}`;
        this.http.get<TramiteItem[]>(url, {observe: 'response'})
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tramitesPorFase.set(result.body)
                        this.tramitesProcesados.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                    if (error.status == 400) {
                        this.tramitesCarrito.set([]) // limpia la variable cuando se elimina el ultimo tramite seleccionado
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.filtrarTramitesCarrito();
                    }, 200)
                }
            });
    }

    /**Obtiene los trámites que estan disponibles sin importar en que pase estan
     * */
    obtenerTramites() {
        let url = apiVucUrl + `api/v1.0/tramites/`;
        return this.http.get<TramiteMntDTO[]>(url, {observe: 'response'});
    }

    /**Procesar los registro de los trámites
     * */
    procesarTramitesGuardar(datosTramites: TramiteMntDTO) {
        datosTramites.creadoPor = this.loginServices.session()?.perfil.usuario!;
        let url = apiVucUrl + `api/v1.0/tramites/`;
        return this.http.post<TramiteMntDTO[]>(url, datosTramites, {observe: 'response'});
    }

    /**Procesar modifcacion de los trámites
     * */
    procesarTramitesEditar(datosTramites: TramiteMntDTO) {
        datosTramites.creadoPor = this.loginServices.session()?.perfil.usuario!;
        datosTramites.idInstitucion = this.loginServices.session()?.perfil.idInstitucion.toString()!;
        let url = apiVucUrl + `api/v1.0/tramites/`;
        return this.http.put<TramiteMntDTO[]>(url, datosTramites, {observe: 'response'});
    }

    /**Procesar update estado de los trámites
     * */
    procesarTramitesEstado(datosTramites: TramiteEstadoDTO) {
        datosTramites.modificadoPor = this.loginServices.session()?.perfil.usuario!;
        let url = apiVucUrl + `api/v1.0/tramites/actualizar-estado`;
        return this.http.put<TramiteEstadoDTO[]>(url, datosTramites, {observe: 'response'});
    }

    /**
     * Calcula y almacena el valor de la tarifa para los datos proporcionados.
     */
    calcularTarifa(datosCalcular: TarifarioInterface[]) {
        console.log(`datosCalcular ->${JSON.stringify(datosCalcular)}`)
        return this.http.post<TarifarioInterface[]>(apiVucUrl + 'api/v1.0/tarifario/calcular', datosCalcular, {observe: 'response'})
    }

    /**
     Almacena los datos de las areas proporcionados del formulario
     */
    procesarAreas(datosAreas: AreasInterfaces[], idProyecto: number) {
        console.log(`datosAreas ->${JSON.stringify(datosAreas)}`)
        return this.http.post<AreasInterfaces[]>(apiVucUrl + `api/v1.0/solicitud/areas/${idProyecto}`, datosAreas, {observe: 'response'})
    }

    /**
     Almacena los datos de las etapas proporcionados del formulario
     */
    procesarEtapas(datosEtapas: EtapasProyectoInterfaces[], idProyecto: number) {
        console.log(`datosEtapas ->${JSON.stringify(datosEtapas)}`)
        return this.http.post<EtapasProyectoInterfaces[]>(apiVucUrl + `api/v1.0/solicitud/etapas/${idProyecto}`, datosEtapas, {observe: 'response'})
    }

    /**
     Almacena los datos de los lotes proporcionados del formulario
     */
    procesarLotes(datosLotes: LoteInterface[], idProyecto: number) {
        console.log(`datosLotes ->${JSON.stringify(datosLotes)}`)
        return this.http.post<LoteInterface[]>(apiVucUrl + `api/v1.0/solicitud/lotes/${idProyecto}`, datosLotes, {observe: 'response'})
    }

    /**
     Almacena los datos de detalle construccion proporcionados del formulario
     */
    procesarDetallesConstruccion(datosDetalleConstruccion: DetalleConstruccionInterface[], idProyecto: number) {
        console.log(`datosDetalleConstruccion ->${JSON.stringify(datosDetalleConstruccion)}`)
        return this.http.post<DetalleConstruccionInterface[]>(apiVucUrl + `api/v1.0/solicitud/detalle-construccion/${idProyecto}`, datosDetalleConstruccion, {observe: 'response'})
    }

    /**
     Almacena los datos de detalle unidades habitacionales proporcionados del formulario
     */
    procesarUnidadesHabitacionales(unidadesHabitacionales: UnidadesHabitacionalesInterface[], idProyecto: number) {
        console.log(`unidadesHabitacionales ->${JSON.stringify(unidadesHabitacionales)}`)
        return this.http.post<UnidadesHabitacionalesInterface[]>(apiVucUrl + `api/v1.0/solicitud/detalle-construccion/${idProyecto}`, unidadesHabitacionales, {observe: 'response'})
    }

    /**
     Almacena los datos de los profesionales y que tipo de profesiona del formulario
     */
    procesarProyectoProfesionalesDet(datosProyectoProfesionalesDet: ProfesionalesTablaInterface[], idProyecto: number) {
        console.log(`datosProyectoProfesionalesDet ->${JSON.stringify(datosProyectoProfesionalesDet)}`)
        return this.http.post<ProfesionalesTablaInterface[]>(apiVucUrl + `api/v1.0/solicitud/proyecto-profesionales-detalle/${idProyecto}`, datosProyectoProfesionalesDet, {observe: 'response'})
    }

    /**
     Almacena los datos de las obras realizadas del formulario
     */
    procesarObrasRealizadasDet(datosObrasRealizadasDet: TipoObrasDetalleInterface[], idProyecto: number) {
        console.log(`datosObrasRealizadasDet ->${JSON.stringify(datosObrasRealizadasDet)}`)
        return this.http.post<ProfesionalesTablaInterface[]>(apiVucUrl + `api/v1.0/solicitud/obra/${idProyecto}`, datosObrasRealizadasDet, {observe: 'response'})
    }

    /**
     Almacena los datos de recepcion de obra detalle  del formulario
     */
    procesarRecepcionObrasDet(datosRecepcionObrasDet: RecepcionObrasDetalleInterface) {
        console.log(`datosObrasRealizadasDet ->${JSON.stringify(datosRecepcionObrasDet)}`)
        return this.http.post<RecepcionObrasDetalleInterface>(apiVucUrl + `api/v1.0/solicitud/etapas/recepcion-detalle`, datosRecepcionObrasDet, {observe: 'response'})
    }

    /**
     Mostrar los datos del captalogo para obras
     */
    mostrarCatalogoDeObras(tipo: number) {
        let url = apiVucUrl + `api/v1.0/solicitud/obra/tipo-obra-urbanizacion/${tipo}`;
        return this.http.get<TipoObrasDetalleInterface[]>(url);
    }

    /**
     Mostrar informacion de lotes y detalle de construccion para la recepcion del proyecto
     */
    mostrarRecepcionProyectoDetalle(idProyecto: number) {
        let url = apiVucUrl + `api/v1.0/solicitud/recepcion-proyecto-detalle?idProyecto=${idProyecto}`;
        return this.http.get<RecepcionProyectoDetalleInterface[]>(url);
    }

    /**
     Actualizar la informacion de lotes y detalle de construccion para la recepcion del proyecto
     */
    updateRecepcionProyectoDetalle(idProyecto: number, datosRecepcionProyecto: RecepcionProyectoDetalleInterface[]) {
        console.log(`datosRecepcionProyecto ->${JSON.stringify(datosRecepcionProyecto)}`)
        return this.http.put<RecepcionProyectoDetalleInterface[]>(apiVucUrl + `api/v1.0/solicitud/recepcion-proyecto-detalle?idProyecto=${idProyecto}`, datosRecepcionProyecto, {observe: 'response'});
    }

    existeAreasConProyecto(idProyecto: number) {
        console.log('existeAreasConProyecto()')
        let url = apiVucUrl + `api/v1.0/solicitud/areas/existe/proyecto/${idProyecto}`;
        return this.http.get<any>(url, {observe: 'response'})
    }

    sessionSaveTramiteTarifario(tramite: TarifarioInterface) {
        console.log(`session save:tramite ->${JSON.stringify(tramite)}`)
        if (tramite != null) {
            sessionStorage.setItem(tramite.idTramite.toString(), JSON.stringify(tramite))
        }
    }

    ngOnDestroy() {
        this.tramitesPorFase = signal([]);
    }

    filtrarTramitesCarrito() {
        console.log(`filtrarTramitesCarrito`)
        console.log(`PorFase    :${JSON.stringify(this.tramitesPorFase().length)}`)
        console.log(`Procesados :${JSON.stringify(this.tramitesProcesados().length)}`)
        let tramites_carrito_filtered = this.tramitesProcesados()
            .filter(e => (e.tramiteEstado?.codigoEstado != EstadoTramiteEnum.Eliminado));
        this.tramitesCarrito.set(tramites_carrito_filtered);
        console.log(`Carrito    :${JSON.stringify(this.tramitesCarrito().length)}`)
    }

    completarSolicitudDetalleRq(idRequisito: number, idProyecto: number) {
        return this.sdetTramiteService.completarSolicitudDetalleRq(this.loginServices.session()?.perfil.usuario!, idRequisito, idProyecto);
    }

    getObtenerTipoAreas(idPoyecto: string, areas: AreasInterfaces[]) {
        const idTipoArea = areas.map(a => a.idTipoArea);
        let url = apiVucUrl + `api/v1.0/solicitud/areas/tipo-areas/proyecto/${idPoyecto}?idsTipoAreas=${idTipoArea}`;
        return this.http.get<AreasInterfaces[]>(url);
    }

    resetStatus() {
        this.initPayload.set(null)
        this.tramitesPorFase.set([])
        this.tramitesProcesados.set([])
    }

    getInitPayload(idProyecto: number) {
        console.log(`getInitPayload -> idProyecto=${idProyecto}`);
        let url = apiVucUrl + `api/v1.0/solicitud/${idProyecto}/disponibles`;
        this.http.get<InitPayload>(url, {observe: 'response'})
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.initPayload.set(result.body!)
                        this.tramitesPorFase.set(result.body.tf)
                        this.tramitesProcesados.set(result.body.tf)
                    }
                },
                error: (error) => {
                    console.log(error)
                    let text = error.mensaje;
                    if (error.error && error.error.mensaje) {
                        text = error.error.mensaje; // Extract the custom message
                    } else if (error.message) {
                        text = error.message; // Fallback to the general error message
                    }
                    if (text.includes('api')) {
                        text = 'Ocurrió un error al procesar, intente mas tarde'
                    }
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: text ? text : "Ocurrió un error al procesar, intente mas tarde",
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                },
                complete: () => {
                    setTimeout(() => {
                        this.filtrarTramitesCarrito();
                    }, 200)
                }
            });
    }

    /**Obtener los detalles de lo tarifarios por idTramite
     * */
    getTarifarioPorIdTramite(idTramite: number) {
        let url = apiVucUrl + `api/v1.0/tramites/${idTramite}/tarifario`;
        return this.http.get<TrafifarioPorTramiteInterface[]>(url, {observe: 'response'});
    }

    getTipoTarifario() {
        let url = apiVucUrl + `api/v1.0/tarifario/tipos`;
        return this.http.get<TarifarioTipoInterface[]>(url);
    }

    getFormula() {
        let url = apiVucUrl + `api/v1.0/tarifario/formulas`;
        return this.http.get<FormulaInterface[]>(url);

    }

    /**Procesar modifcacion de los tarifario
     * */
    procesarTarifarioEditar(datosTarifario: TarifarioMantenimientoInterface) {
        datosTarifario.modificadoPor = this.loginServices.session()?.perfil.usuario!;
        let url = apiVucUrl + `api/v1.0/tarifario/`;
        return this.http.put<TarifarioMantenimientoInterface[]>(url, datosTarifario, {observe: 'response'});
    }

    /**Procesar los registro de los tarifarios
     * */
    procesarTarifarioGuardar(datosTarifario: TarifarioMantenimientoInterface) {
        datosTarifario.creadoPor = this.loginServices.session()?.perfil.usuario!;
        // datosTramites.idInstitucion=this.loginServices.session()?.perfil.idInstitucion.toString()!;
        let url = apiVucUrl + `api/v1.0/tarifario/`;
        return this.http.post<TarifarioMantenimientoInterface[]>(url, datosTarifario, {observe: 'response'});
    }

    /**Procesar update estado de los tarifario
     * */
    procesarTarifarioEstado(datosTarifario: TarifarioEstadoDTO) {
        datosTarifario.modificadoPor = this.loginServices.session()?.perfil.usuario!;
        let url = apiVucUrl + `api/v1.0/tarifario/actualizar-estado`;
        return this.http.put<TramiteEstadoDTO[]>(url, datosTarifario, {observe: 'response'});
    }

    /**Metodo que asigna al tramite la lista de requisitos seleccionados*/
    agregarTramitesRequisitos(tramitesRequisitos: TramitesRequisitos) {
        console.log(`agregarTramitesRequisitos ->${JSON.stringify(tramitesRequisitos)}`)
        return this.http.post<TramitesRequisitos>(apiVucUrl + `api/v1.0/tramites/requisitos/agregar`, tramitesRequisitos, {observe: 'response'})
    }

    actualizarEstadoTramitesRequisitos(tramitesRequisitos: TramiteRequisitoEstado, idTramite: number) {
        console.log(`actualizarEstadoTramitesRequisitos ->${JSON.stringify(tramitesRequisitos)}`)
        return this.http.put<TramiteRequisitoEstado>(apiVucUrl + `api/v1.0/tramites/requisitos/actualizar-estado?idTramite=${idTramite}`, tramitesRequisitos, {observe: 'response'})
    }

    actualizarOpcionalTramitesRequisitos(tramitesRequisitos: TramiteRequisitoEstado, idTramite: number) {
        console.log(`actualizarOpcionalTramitesRequisitos ->${JSON.stringify(tramitesRequisitos)}`)
        return this.http.put<TramiteRequisitoEstado>(apiVucUrl + `api/v1.0/tramites/requisitos/actualizar-opcional?idTramite=${idTramite}`, tramitesRequisitos, {observe: 'response'})
    }

    actualizarOrdenTramitesRequisitos(tramitesRequisitos: TramiteRequisitoOrden[]) {
        console.log(`actualizarOrdenTramitesRequisitos ->${JSON.stringify(tramitesRequisitos)}`)
        return this.http.put<TramiteRequisitoOrden[]>(apiVucUrl + `api/v1.0/tramites/requisitos/actualizar-orden`, tramitesRequisitos, {observe: 'response'})
    }

    /**desactiva todos los requisitos seleccionados para el tramite que pertenecen*/
    actualizarEstadosTramitesRequisitos(tramitesRequisitosSeleccionados: TramitesRequisitosSeleccionados, idTramite: number) {
        console.log(`actualizarEstadosTramitesRequisitos ->${JSON.stringify(tramitesRequisitosSeleccionados)}`)
        return this.http.put<TramitesRequisitosSeleccionados>(apiVucUrl + `api/v1.0/tramites/requisitos/estados-tramites-requisitos?idTramite=${idTramite}`, tramitesRequisitosSeleccionados, {observe: 'response'})
    }

aprobarSolicitud(idProyecto: number, usuario: String) {
    console.log(`aprobarSolicitud ->idProyecto=${idProyecto}, usuario=${usuario}`);
    const body = { idProyecto: idProyecto, usuario:usuario };
    return this.http.post(apiVucUrl + `api/v1.0/solicitud/aprobar`, body, { observe: 'response' });
}


    /**
     * Metodo que muestra los tramites a evaluar por fase que a seleccionado el proyecto*/
    getTramitesFasesEvaluacion(idProyecto: number) {
        console.log(`getTramitesFasesEvaluacion ->idProyecto=${idProyecto}`);
        let url = apiVucUrl + `api/v1.0/tramites/${idProyecto}/evalTramites`;
        this.http.get<SolicitudEvalTramiteFase[]>(url, {observe: 'response'})
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._tramitesFasesEval.set(result.body);
                        this.evaluacionesService.datosCargados=true;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {

                }
            });
    }
    //Metodo para actualizar las generales del proyecto al seleccionar tramites
    getGeneralesProyectoUpdate(id: string) {
        this.proyectoService.getGeneralesProyecto(id!)
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        let proyecto = result.body
                        this.selected.set(proyecto![0]);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {

                }
            });
    }
    /**
     * Obtiene tramite con la url del formulario que correspondiente.
     */
     initFormSdet(sdet: SdetInterface) {
        return this.sdetTramiteService.initFormSdet(sdet)
    }
    /**
     Actualiza los datos de detalle unidades habitacionales cuando se remueven
     */
    updateEstadoDetalleUnidades(unidadesHabitacionales: UnidadesHabitacionalesInterface) {
        return this.http.put<UnidadesHabitacionalesInterface>(apiVucUrl + `api/v1.0/solicitud/detalle-construccion/`, unidadesHabitacionales, {observe: 'response'})
    }
    /**
     Actualiza los datos de detalle profesional cuando se remueven
     */
    updateEstadoDetalleProfesional(unidadesProfesionales: ProfesionalesTablaInterface) {
        return this.http.put<ProfesionalesTablaInterface>(apiVucUrl + `api/v1.0/solicitud/proyecto-profesionales-detalle/`, unidadesProfesionales, {observe: 'response'})
    }

    /**
     Actualiza los datos de los lotes proporcionados cuando se remueven
     */
    updateEstadoLotes(datosLotes: LoteInterface) {
        return this.http.put<LoteInterface>(apiVucUrl + `api/v1.0/solicitud/lotes/estado`, datosLotes, {observe: 'response'})
    }
}
